const config = {
  type: 'voucher',
  activator: {
    type: 'notesField',
    text: 'AH voucheractie'
  },
  startDate: '2024/04/28',
  endDate: '2025/04/23',
  excludedDates: [
    '2024-04-01',
    '2024-05-09',
    ['2024-12-21', '2025-01-05'],
    '2025-04-21',
    '2025-05-05',
    '2025-05-29',
    '2025-06-09',
    ['2025-12-20', '2026-01-04']
  ],
  maxGroupSize: 14,
  locations: [
    {
      id: '073d8084-de0c-47b0-a1a5-8f26de05e6c6',
      name: 'Loetje Almere Centrum',
      start_time: '12:00',
      end_time: '16:00',
      excludedDates: [
        '2024-05-20'
      ]
    },
    {
      id: '46f6ef79-3caa-4ad7-8e4c-a0d71ded7c2d',
      name: 'Loetje Almere Noorderplassen',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '31c1d494-f503-4012-9e28-d489b34b8c64',
      name: "Loetje Amsterdam aan 't IJ",
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '95e356b8-100c-4d24-9114-fc01a1e4e7c5',
      name: 'Loetje Amsterdam Café',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: 'bd3c7497-7dde-4707-b82f-5916d560b0d7',
      name: 'Loetje Amsterdam de Pijp',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '8c4cbf41-116d-4b65-af4f-9445c7ceb303',
      name: 'Loetje Amsterdam Oost',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: 'e5cb1ae5-e33e-4704-ab84-151a10fd02cc',
      name: 'Loetje Amsterdam ZuidAs',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '421c8266-67d6-4706-af6a-fa55af035ddc',
      name: 'Loetje Arnhem',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '59c148c0-82f5-453c-a8f7-a6cf7252965d',
      name: 'Loetje Bergen',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: 'f546558b-693d-407a-9652-3732a647d45c',
      name: 'Loetje Breda',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '2d519dcc-47d3-478a-b13f-c7892791f2b1',
      name: 'Loetje Breukelen',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '870161c9-4eed-4e96-914a-ee8dca65ec62',
      name: 'Loetje Delft',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '6907a272-a59d-45f6-890e-6cae57604afb',
      name: 'Loetje Den Haag Binckhorst',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: 'c5049038-c04d-4812-aba9-0227d692bdf6',
      name: 'Loetje Den Haag Centrum',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '1451d489-91da-45bd-b9ba-a2badf8df562',
      name: 'Loetje Eindhoven',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '30077c4b-e4b4-4696-b4c7-ecbf5a2eca54',
      name: 'Loetje Enschede',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: 'c42fa1a7-4555-42fc-81b5-30e8c971dd1a',
      name: 'Loetje Gorssel',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: 'b81893d2-89d7-44d7-ac4a-d1180a337183',
      name: 'Loetje Haarlem',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '87c967ba-6820-4c93-95ea-a5f42ce74d57',
      name: 'Loetje Hilversum',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '088dc63e-cd1d-4a3a-a0b1-c707a27263b9',
      name: 'Loetje Houten',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '7acd55e7-a1e9-4fa2-93d7-8c7a641d03f3',
      name: 'Loetje Huizen',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '2a42dc37-94e4-48de-9c72-d45e8f84879f',
      name: 'Loetje Laren',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '99899aa7-7c5e-4de2-873f-5378c9a587fb',
      name: 'Loetje Leeuwarden',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: 'bb344a63-4840-4afc-9320-4ff0d411ee85',
      name: 'Loetje Leiden',
      start_time: '12:00',
      end_time: '16:00',
      excludedDates: [
        '2024-05-20'
      ]
    },
    {
      id: 'fc26a292-ce6f-4135-a6d7-c103ae956ef0',
      name: 'Loetje Maastricht',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '9203dd5b-93e7-4498-92bd-70e86e8cab5d',
      name: 'Loetje Nijmegen',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '28e4f8d5-6934-49c7-9730-7b49cfa4d79d',
      name: 'Loetje Ouderkerk aan de Amstel',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '9a6177e2-0d9b-48eb-84a1-fafff4074733',
      name: 'Loetje Overveen',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '214359e2-ce29-43d9-b439-5cb6765673de',
      name: 'Loetje Paterswolde',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '1334954c-211b-405f-b4a6-369a684dcb86',
      name: 'Loetje Reeuwijk',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '31cb5eee-6399-4d2a-a99d-2978aeb35007',
      name: 'Loetje Rotterdam Centrum',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '3f9cefaa-c00a-40c6-96ba-0047725c050b',
      name: 'Loetje Rotterdam Kop van Zuid',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '70d0ea6f-0da9-499f-8063-380ccf0b3e66',
      name: 'Loetje Utrecht',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: 'deda9f31-5bf1-4efa-8e1d-7dc2f1d6fd21',
      name: 'Loetje Vught',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '1909edb7-0cdb-46dc-8010-d1a8ea05bf76',
      name: 'Loetje Zeist',
      start_time: '12:00',
      end_time: '16:00'
    },
    {
      id: '688f61d3-278c-4283-acc3-3570e7b8c9df',
      name: 'Loetje Zwolle',
      start_time: '12:00',
      end_time: '16:00'
    }
  ]
}

module.exports = config
